export default "__VITE_ASSET__fGXRV2Xw__"